import { render } from "./EmployerData.vue?vue&type=template&id=36dd4148&scoped=true"
import script from "./EmployerData.vue?vue&type=script&lang=js"
export * from "./EmployerData.vue?vue&type=script&lang=js"

import "./EmployerData.vue?vue&type=style&index=0&id=36dd4148&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dd4148"]])

export default __exports__